import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { TipoCartera } from '@p-p-portafolio/interfaces/tipoCartera';
import { EntityOperationResult } from '@shared/interfaces/responses/entity-operation-result';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class TipoCarteraService {
  private baseUrl = environment.apiBaseUrl + 'api/tipocartera';
  private newBackBaseUrl = environment.apiNewBackBaseUrl;
  private user = localStorage.getItem('user')
    ? localStorage.getItem('user')
    : 'Invitado';

  constructor(private http: HttpClient) {}

  form: UntypedFormGroup = new UntypedFormGroup({
    sCartera: new UntypedFormControl(null, [Validators.required]),
    descripcion: new UntypedFormControl('', [Validators.maxLength(40)]),
  });

  initializeFormGroup() {
    this.form.setValue({
      sCartera: null,
      descripcion: null,
    });
  }

  populateForm(entity: TipoCartera) {
    this.form.setValue(entity);
  }

  getAll() {
    const url = `${this.baseUrl}`;
    return this.http.get<TipoCartera[]>(url);
  }

  getById(id: string) {
    const url = `${this.baseUrl}/${id}`;
    return this.http.get<TipoCartera>(url);
  }

  add(entity: TipoCartera) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    const url = `${this.baseUrl}/add`;
    return this.http.post<EntityOperationResult>(
      url + '/' + this.user,
      entity,
      httpOptions
    );
  }

  saveTipoCartera(payload: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    const url = `${this.newBackBaseUrl}TipoCartera/caspa_TipoCarteraAdd`;
    return this.http.post<EntityOperationResult>(
      url,
      payload,
      httpOptions
    );
  }

  updateTipoCartera(payload: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    const url = `${this.newBackBaseUrl}TipoCartera/caspa_TipoCarteraUpd`;
    return this.http.post<EntityOperationResult>(
      url,
      payload,
      httpOptions
    );
  }

  update(entity: TipoCartera) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    const url = `${this.baseUrl}/upd`;
    return this.http.put<EntityOperationResult>(
      url + '/' + this.user,
      entity,
      httpOptions
    );
  }

  delete(entity: TipoCartera) {
    const url = `${this.baseUrl}/del`;
    return this.http.request<EntityOperationResult>(
      'delete',
      url + '/' + this.user,
      { body: entity }
    );
  }
}
